import { CloseCircleOutlined, LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Checkbox, Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Slider from 'react-slick';
import { generateComparePDF } from '../../utils/api';

const CompareCars = () => {
    const location = useLocation();
    const [query] = useSearchParams();
    const isUpdate = query.get("update");
    const navigate = useNavigate();
    const [compareCars, setCompareCars] = useState([]);
    const [checkGenerate, setCheckedGenerate] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (location?.state?.CompareCars) {
            if (location?.state?.CompareCars.length === 4) {
                let data = location?.state?.CompareCars
                localStorage.setItem("compareCars", JSON.stringify(data));
                setCompareCars(data);
            } else {
                let data = [...location?.state?.CompareCars, { emptyData: true }];
                setCompareCars(data);
            }
        }
    }, [location]);

    useEffect(() => {
        if (checkGenerate.length) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true)
        }
    }, [checkGenerate])

    const handleRemove = (id) => {
        const filtered = compareCars.filter((item) => {
            return id !== item?.carDetail?.vin
        })
        setCompareCars(filtered);
        let filterGenerate = filtered.filter((item) => {
            return checkGenerate.includes(item?.carDetail?.vin)
        }).map((item) => item?.carDetail?.vin)
        setCheckedGenerate(filterGenerate);
        let filterEmptyData = filtered.filter((item) => {
            return !item.emptyData
        })
        localStorage.setItem("compareCars", JSON.stringify(filterEmptyData))
        if (!filtered[filtered.length - 1].emptyData) {
            setCompareCars([...filtered, { emptyData: true }]);
        } else {
            if (filtered.length === 2) {
                navigate("/find_car", {
                    state: { filterInput: location?.state?.filters, formInputValues: location?.state?.inputFormValues },
                });
            }
        }
    }

    const handleCheckChange = (e, car) => {
        let res = car?.carDetail?.vin
        if (e.target.checked) {
            setCheckedGenerate([...checkGenerate, res]);
        } else {
            let filtered = checkGenerate.filter((item) => {
                return item !== res
            })
            setCheckedGenerate(filtered)
        }
    }

    const handleGenerate = () => {
        let payload = compareCars.filter((item) => {
            return checkGenerate.includes(item?.carDetail?.vin)
        })
        setLoading(true);
        generateComparePDF({ slectedCars: payload, marketValueList: location?.state?.inputFormValues })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `report.pdf`);
                document.body.appendChild(link);
                link.click();
                setLoading(false);
                localStorage.removeItem("compareCars");
                navigate("/form_page");
            })
            .catch(() => {
                setLoading(false);
            });
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const handleAddToReport = () => {
        let selectedCars = compareCars.filter((item) => {
            return checkGenerate.includes(item?.carDetail?.vin)
        });
        localStorage.setItem("marketCars", JSON.stringify(selectedCars));
        if (isUpdate) {
            navigate("/generatePage");
        } else {
            navigate("/find_salvageCar");
        }
    }
    return (
        <>
            <Spin
                spinning={loading}
                indicator={
                    <LoadingOutlined
                        style={{
                            fontSize: 48,
                            color: 'black',
                        }}
                        spin
                    />
                }
            >
                <div className='p-4 md:p-12'>
                    <div className='flex justify-between md:flex-row flex-col flex-wrap gap-16 xl:gap-0'>
                        {compareCars.map((res, i) => {
                            return <>
                                <div className="w-full sm:w-[-webkit-fill-available] md:w-[45%] xl:w-[22%]" >

                                    {!compareCars[i].emptyData ? <div style={{ height: "338px" }}>
                                        <div
                                            style={{
                                                boxShadow: '1px 0px 12px 2px #57575733',
                                                border: '0.5px solid #7D7D7D',
                                                height: "100%"
                                            }}
                                        >
                                            {
                                                <div className='slider-container min-h-[222px] findCardSlider relative'>
                                                    {res?.carDetail?.photoUrls && <>
                                                        {res?.carDetail?.photoUrls && <img src={res?.carDetail?.photoUrls[0]} alt='' className='w-full object-fill max-h-[220px]' />}
                                                        <div className='absolute top-[-12px] bg-white right-[-12px] rounded-[50%] flex items-center cursor-pointer'>
                                                            <CloseCircleOutlined className='text-[30px]' onClick={() => handleRemove(res?.carDetail?.vin)} />
                                                        </div>
                                                    </>}
                                                </div>
                                            }
                                            {
                                                res?.carDetail && <>
                                                    <div className='flex flex-col justify-between h-[114px]'>
                                                        <div className='p-3'>
                                                            <h2 className='font-semibold'>
                                                                {res?.carDetail?.year} {res?.carDetail?.make} {res?.carDetail?.model}
                                                            </h2>
                                                        </div>
                                                        <div className='p-3 pt-0 text-[20px]'>
                                                            <h2 className='font-normal'>
                                                                <b>Price: {res?.carDetail?.price}</b></h2>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div> : <div className='flex justify-center items-center'>
                                        <div className='p-3 pt-[64px]'>
                                            <div className='text-[60px] flex justify-center'>
                                                <PlusCircleOutlined className='cursor-pointer' onClick={() => navigate('/find_car', {
                                                    state: { filterInput: location?.state?.filters, formInputValues: location?.state?.inputFormValues },
                                                })} />
                                            </div>
                                            <h2 className='font-semibold mt-4'>
                                                Add More car to compare
                                            </h2>
                                        </div>
                                    </div>}

                                    {!compareCars[i].emptyData &&
                                        <>
                                            <div className='border-t mt-16 border-b'>
                                            </div>
                                            <div >
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Brand
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.make?.name ? res?.overView?.make?.name : "-"}</b></h2>
                                                </div>
                                            </div>
                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Model
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.model?.name ? res?.overView?.model?.name : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Engine
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.engine?.name ? res?.overView?.engine?.name : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Horsepower
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.engine?.horsepower ? res?.overView?.engine?.horsepower + "hp@" + res?.overView?.engine?.rpm?.horsepower + "rpm" : "-"}</b></h2>
                                                </div>
                                            </div>


                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Displacement
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.engine?.displacement ? res?.overView?.engine?.displacement + "CC" : "-"}</b></h2>
                                                </div>
                                            </div>


                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Torque
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.engine?.torque ? res?.overView?.engine?.torque + "hp@" + res?.overView?.engine?.rpm?.torque + "rpm" : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Transmission
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.transmission?.transmissionType ? res?.overView?.transmission?.transmissionType : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Cylinders
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.engine?.cylinder ? res?.overView?.engine?.cylinder : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Vehicle Type
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.categories?.vehicleType ? res?.overView?.categories?.vehicleType : "-"}</b></h2>
                                                </div>
                                            </div>
                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            City Mileage
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.mpg?.city ? res?.overView?.mpg?.city : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Highway Mileage
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.mpg?.highway ? res?.overView?.mpg?.highway : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Number Of Doors
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.numOfDoors ? res?.overView?.numOfDoors : "-"}</b></h2>
                                                </div>
                                            </div>

                                            <div className='mt-2'>
                                                <div className='flex'>
                                                    <div className='p-3 pb-0'>
                                                        <h2 className='font-semibold'>
                                                            Driven Wheels
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='p-3 pt-0 text-[18px]'>
                                                    <h2 className='font-semibold'>
                                                        <b>{res?.overView?.drivenWheels ? res?.overView?.drivenWheels : "-"}</b></h2>
                                                </div>
                                            </div>
                                            <Checkbox checked={checkGenerate.includes(res?.carDetail?.vin)} className='custom-checkbox my-4' onChange={(e) => handleCheckChange(e, res)}>Add To Condition Report</Checkbox>
                                        </>
                                    }
                                </div>
                            </>
                        })}
                    </div>

                    <div className='flex justify-center mt-12'>
                        <button className={`${isDisabled ? "bg-[#d7dbde]" : "darkBlue"} px-[52px] py-[25px] text-white text-lg mb-[31px]`} disabled={isDisabled} onClick={handleAddToReport} >
                            Add to Condition Report
                        </button>
                    </div>
                </div>
            </Spin>
        </>
    )
}

export default CompareCars
